export default "__VITE_ASSET__DKRARzPR__"